import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/components/protection-modal/关闭弹窗.png")